import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Services.css';
import useLanguage from '../hooks/useLanguage';

const serviceIcons = [
  'bi bi-file-earmark-text',
  'bi bi-bank',
  'bi bi-clipboard-check',
  'bi bi-people',
];

const Services = () => {
  const { t, language, translations } = useLanguage();

  return (
    <section id="services" className="services-section py-5">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center mb-5">
            <h2 className="display-5 fw-bold text-dark mb-3">{t('services', 'title')}</h2>
            <p className="lead text-muted">
              {t('services', 'subtitle')}
            </p>
          </div>
        </div>

        <div className="row g-4">
          {translations.services.cards.map((card, index) => (
            <div key={index} className="col-lg-6 col-md-6">
              <div className="service-card" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="service-icon">
                  <i className={serviceIcons[index]}></i>
                </div>
                <h3 className="service-title">{card.title[language]}</h3>
                <p className="service-description">{card.description[language]}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
